export const PORTAL_SCROLL_ROOT_ID: string = 'portal-scroll-root';

export function getPortalScrollRoot(): HTMLElement | null {
    const scrollRoot = document.getElementById(PORTAL_SCROLL_ROOT_ID);
    return scrollRoot instanceof HTMLElement ? scrollRoot : null;
}

export function scrollPortalContentToTop(): void {
    const scrollRoot = getPortalScrollRoot();
    if (scrollRoot !== null) {
        scrollRoot.scrollTo({ left: 0, top: 0 });
        return;
    }

    window.scrollTo({ left: 0, top: 0 });
}
